export default class Backend {
  async init() {
    const config = await fetch("/config.json").then((r) => r.json());
    const host = window.location.hostname;
    const domainConfig = config[host] || config["localhost"];

    this.api_link = domainConfig.API_BASE_URL;
    this.EntryKey = domainConfig.ENTRYKEY;

    return this; // allow chaining
  }

  update(data) {
    return fetch(this.api_link + "/update", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  login(data) {
    return fetch(this.api_link + "/login", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  contact(data) {
    return fetch(this.api_link + "/contact", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
  consultation(data) {
    return fetch(this.api_link + "/consultation", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey
      },
      body: data,
    }).then((response) => response.json());
  }
  subscribe(data) {
    return fetch(this.api_link + "/subscribe", {
      method: "POST",
      headers: {
        EntryKey: this.EntryKey,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        data: data,
      }),
    }).then((response) => response.json());
  }
}
